<template>
  <v-container fluid>
    <guia :codtipoguia="'N'" />
  </v-container>
</template>
<script>
import Guia from '../components/Guia.vue'
export default {
  components: { Guia }
}
</script>

<style>

</style>
